import {Component, ComponentFactoryResolver, OnInit, ViewChild, Input, Output, EventEmitter} from "@angular/core";
import {AppService} from "@api";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {TranslateService} from "@ngx-translate/core";

import {DxTreeViewComponent} from "devextreme-angular";

import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {SistemaService} from "@servicios/Sistema.Service";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";

@Component(
    {
        selector: 'asignacionalumnonmodal',
        templateUrl: './asignacionalumno.template.html',
        styleUrls: ['./asignacionalumno.component.scss']
    })

export class AsignacionAlumnoModal implements OnInit {
    @Input() cicloid!: number;
    @Input() nivelid!: number;
    @Input() gradoid: number = 0;
    @Input() periodoevaluacionportipoevaluacionid!: number;
    @Input() limitealumnosgrupoaleatorio: number = 20;
    @Output() respuesta = new EventEmitter();

    @ViewChild(DxTreeViewComponent, {static: false}) treeView!: DxTreeViewComponent;

    public abierto!: boolean;
    public animacion!: string;

    listacolaboradores!: any[];

    SelTipoAsignacion: any[];
    tipoasignacionalumnocolaboradorid!: number;
    numero!: string;
    errorActivo!: boolean;

    createChildren: any;
    seleccionado!: any[]

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
        this.listacolaboradores = [];
        this.SelTipoAsignacion = [];

        this.createChildren = (parent: any) => {
            if (parent && parent?.itemData.grupoid) {
                return this.LoadAlumnos(parent);
            }
            return;
        };
    }

    ngOnInit() {
        this.SetListaAsignacionAlumno();
    }

    SetListaAsignacionAlumno() {
        this.appService.Get("catalogo/tipoasignacionalumnoscolaborador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelTipoAsignacion = res.data;
            }
        })
    }

    LoadTree() {
        return new Promise((resolve) => {
            let data = {cicloid: this.cicloid, nivelid: this.nivelid, gradoid: this.gradoid, periodoevaluacionportipoevaluacionid: this.periodoevaluacionportipoevaluacionid}
            this.appService.Post("catalogo/tree/nivel", data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.treeView.instance.option("items", res.data);
                    return resolve(1);
                } else {
                    return resolve(0);
                }
            })
        });
    }

    LoadAlumnos(parent: any) {
        return new Promise((resolve) => {
            this.appService.Get("catalogo/tree/nivel/grado/grupo/" + parent.itemData.grupoid).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    return resolve(res.data);
                } else {
                    return resolve(null);
                }
            })
        });
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.LoadTree();
    }

    CerrarModal() {
        this.animacion = this.sistemaService.animacionCerrarModal;
        this.Reset();
        this.tipoasignacionalumnocolaboradorid = 0;
        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Reset() {
        this.numero = '';
        this.errorActivo = false;
        this.treeView.instance.unselectAll();
    }

    Modalidad(e: number) {
        this.Reset();
        if (e == 2) {
            this.treeView.instance.selectAll()
        }
    }

    asignar() {
        this.errorActivo = true;
        if (!this.numero || !this.numero.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, 'Ingrese un número');
        }

        let data = {cicloid: this.cicloid, nivelid: this.nivelid, gradoid: this.gradoid, numero: this.numero, periodoevaluacionportipoevaluacionid: this.periodoevaluacionportipoevaluacionid}
        this.appService.Post("catalogo/tree/asignacion", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.treeView.instance.option("items", res.data);
            }
        });
    }

    Guardar() {
        this.seleccionado = [];
        this.treeView.instance.getNodes().map((node) => {
            this.formato(node);
        });

        if (!this.seleccionado.length) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, 'Seleccione mínimo un registro');
        }
        this.respuesta.next(this.seleccionado)
    }

    formato(item: any) {
        if (item.selected) {
            this.seleccionado.push(item.itemData);
            return;
        } else {
            (item.items as any[]).forEach((node) => {
                this.formato(node);
            })
        }
    }

    Editar(alumnos: any[]) {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.tipoasignacionalumnocolaboradorid = 3;

        let data = {cicloid: this.cicloid, nivelid: this.nivelid, gradoid: this.gradoid, periodoevaluacionportipoevaluacionid: this.periodoevaluacionportipoevaluacionid, alumnos: alumnos}
        this.appService.Post("catalogo/tree/alumno", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.treeView.instance.option("items", res.data);
            }
        });
    }

}
